export default {"src":"/_next/static/media/no-artificial-flavors.55494ef7.svg","height":71,"width":69,"blurWidth":0,"blurHeight":0};